import { createSlice, PayloadAction, PrepareAction } from '@reduxjs/toolkit'

interface Genre {
  id: string
  label: string
  name: string
}

interface GenreState {
  genres: Genre[]
  selectedGenres: string[]
  loading: boolean
  error?: unknown
}

const initialState: GenreState = {
  genres: [],
  selectedGenres: [],
  loading: false,
}

const genreSlice = createSlice({
  name: 'genre',
  initialState,
  reducers: {
    loadingGenres: (state) => {
      state.loading = true
    },
    loadingGenresSuccess: (state, action: PayloadAction<Genre[]>) => {
      state.genres = action.payload
      state.loading = false
    },
    loadingGenresFail: (state, action: PayloadAction<unknown>) => {
      state.error = action.payload
      state.loading = false
    },
    setSelectedGenres: (state, action: PayloadAction<string[]>) => {
      state.selectedGenres = action.payload
    },
    toggleGenre: {
      prepare(name: string, value: boolean) {
        return { payload: { name, value } }
      },
      reducer(state, action: PayloadAction<{ name: string; value: boolean }>) {
        const { name, value } = action.payload
        if (value && !state.selectedGenres.includes(name)) {
          state.selectedGenres.push(name)
        } else {
          state.selectedGenres = state.selectedGenres.filter((item) => item !== name)
        }
      },
    },
    clearGenres: (state) => {
      state.selectedGenres = []
    },
    reset: () => initialState,
  },
})

export const genreActions = genreSlice.actions
export const genreReducer = genreSlice.reducer
export default genreActions
